import {
  NodeBasicPage,
  NodeNews,
  NodeBlog,
  NodeProject,
  NodeVideoSelection,
  NodeLandingPage,
  PersonTeaser,
  PartnerPage,
  FAQ,
  Foundation,
  MemberStory,
  NodeGuide,
  NodeSIAProject,
  NodeKPAnswerPage,
  NodeKPLandingPage,
  NodeKPQuestionPage,
  NodeHomePage,
  NodeMaatjesProject,
  NodeStory,
  NodeNLdoetProject,
} from '../implementations';

const mappers = {
  myof_item: NodeBasicPage,
  news: NodeNews,
  blog: NodeBlog,
  page: NodeBasicPage,
  basic_page: NodeBasicPage,
  partner: PartnerPage,
  project: NodeProject,
  fonds_op_naam: Foundation,
  video_selection: NodeVideoSelection,
  landing_page: NodeLandingPage,
  person: PersonTeaser,
  faq_question: FAQ,
  member_story: MemberStory,
  guide: NodeGuide,
  sia_project: NodeSIAProject,
  kp_answer: NodeKPAnswerPage,
  kp_landing_page: NodeKPLandingPage,
  kp_question: NodeKPQuestionPage,
  homepage: NodeHomePage,
  story: NodeStory,
  maatjes_project: NodeMaatjesProject,
  nldoet_project: NodeNLdoetProject,
};

export default mappers;
